import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchData, CREATE_NRI_TALK } from "../../components/Service";
import { toast } from "react-toastify";
import { Context } from "../../components/Context";
import Dropzone from "../../components/Dropzone";
import {useNavigate,} from "../../../node_modules/react-router-dom/dist/index";


const CreateNriTalk = () => {
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [image, setImage] = useState("");
	const [video, setVideo] = useState("");
	const [audio, setAudio] = useState("");

	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
		setError,
		clearErrors,
	} = useForm({ mode: "onChange" });

	// Handle file drop
	const onFileDrop = (file, type) => {
		if (type === "video") {
			setVideo(file);
		} else if (type === "audio") {
			setAudio(file);
		} else {
			setImage(file);
		}
	};

	const createData = (data) => {
		const formData = new FormData();

		formData.append("user_id", context?.user?.user_id);
		formData.append("state_id", context?.stateId);
		formData.append("country_id", context?.countryId);
		formData.append("title", data?.title);
		formData.append("description", data?.description);
		formData.append("audio", audio);
		formData.append("video", video);
		formData.append("image", image);

		fetchData(CREATE_NRI_TALK, "POST", formData, true, true, (res) => {
			if (res.status) {
				toast.success("NRI talk created successfully.");
				navigate(`/profile?tab=ads`);
				reset();

				window.$("#createNriTalkModal").modal("hide");
			} else {
				toast.error("Unable to create NRI talk.");
			}
		});
	};

	return (
		<div
			className="modal fade pe-0"
			id="createNriTalkModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content">
					<button
						className="btn-close"
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={() => {
							reset();
							setImage("");
							setAudio("");
							setVideo("");
						}}
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<h5 className="text-brand-1 text-capitalize">Create NRI's Talk</h5>
					</div>
					<div className="modal-body px-4 px-xl-5 py-3">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(createData)}>
							<div className="row">
								<div className="col-12 mb-2">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.title && "is-invalid"}`}
										placeholder="Title"
										maxLength={60}
										{...register("title", {
											required: { value: true, message: "Title is required." },
										})}
									/>
									{errors.title && <div class="invalid-feedback">{errors.title.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Description <span className="text-danger">*</span>
									</label>
									<textarea
										class={`form-control ${errors.description && "is-invalid"}`}
										rows="5"
										placeholder="Description"
										{...register("description", {
											required: { value: true, message: "Description is required." },
										})}
									></textarea>
									{errors.description && <div class="invalid-feedback d-block">{errors.description.message}</div>}
								</div>
								<div className="col-md-12">
									<div class="mb-2">
										<label class="form-label font12 d-flex">
											Image <span class="invalid-feedback d-block m-0 ms-2"> (formats: jpeg, png, gif supported.)</span>
										</label>
										<Dropzone key="image" onFileDrop={onFileDrop} setError={setError} clearErrors={clearErrors} uploadFile="image" fieldName="image" fileName={image} />
										{image && <p>File Name: {image?.name}</p>}
										{errors?.image && <div class="invalid-feedback d-block">{errors?.image?.message}</div>}
									</div>
								</div>
								<div className="col-md-12">
									<div class="mb-2">
										<label class="form-label font12 d-flex">
											Video<span class="invalid-feedback d-block m-0 ms-2"> (formats: mp4 , x-m4v ,video/* supported.)</span>
										</label>
										<Dropzone key="video" onFileDrop={onFileDrop} setError={setError} clearErrors={clearErrors} uploadFile="video" fieldName="video" fileName={video} />
										{video && <p>File Name: {video.name}</p>}
										{errors?.video && <div class="invalid-feedback d-block">{errors?.video?.message}</div>}
									</div>
								</div>
								<div className="col-md-12">
									<div class="mb-2">
										<label class="form-label font12 d-flex">
											Audio<span class="invalid-feedback d-block m-0 ms-2"> (formats:mp3 , mpeg ,audio/* supported.)</span>
										</label>
										<Dropzone key="audio" onFileDrop={onFileDrop} setError={setError} clearErrors={clearErrors} uploadFile="audio" fieldName="audio" fileName={audio} />
										{audio && <p>File Name: {audio.name}</p>}
										{errors?.audio && <div class="invalid-feedback d-block">{errors?.audio?.message}</div>}
									</div>
								</div>
							</div>
							<div className="modal-footer d-block text-center border-0">
								<button className={`btn btn-default hover-up m-auto`} type="submit" name="Submit">
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateNriTalk;
